
import { OLMSApiService } from '@/shared/apis'
import { RootState } from '@/shared/store'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

import { getShiftsStopsFromRunsheets } from '../libs/getShiftsStopsFromRunsheets'
import { getShiftsStopsFromScenarios } from '../libs/getShiftsStopsFromScenarios'
import { Scenario } from '../models/planning/Scenario'
import { Runsheet } from '../models/runsheet/Runsheet'
import { upsertMultiplePlanningShifts } from '../slices/planningShiftsSlice'
import { upsertMultiplePlanningStops } from '../slices/planningStopsSlice'
import { upsertMultipleRunsheetShifts } from '../slices/runsheetShiftsSlice'
import { upsertMultipleRunsheetStops } from '../slices/runsheetStopsSlice'

type ShiftPayload = {
  runId: EntityId
}

export type AddShiftsPayload = {
  id: EntityId // The Scenario Id
  shifts: ShiftPayload[]
  onSuccess?: () => void
}

export const addShifts = createAsyncThunk<void, AddShiftsPayload, { state: RootState }>(
  'schedules/addShifts',
  async ({ id, shifts, onSuccess }, { getState, dispatch }) => {
    const state = getState()
    const currentScreen = state.userInterface.currentScreen

    if (currentScreen === 'planning') {
      const scenario = await OLMSApiService.post<Scenario>('/planning/addShifts', {
        id: id,
        shifts: shifts,
      })

      if (!scenario) return

      const { shifts: planningShifts, stops: planningStops } = getShiftsStopsFromScenarios([scenario])

      dispatch(upsertMultiplePlanningShifts(planningShifts))
      dispatch(upsertMultiplePlanningStops(planningStops))
    }
    else {
      const runsheet = await OLMSApiService.post<Runsheet>('/runsheet/addShifts', {
        id: id,
        shifts: shifts,
      })

      if (!runsheet) return

      const { shifts: runsheetShifts, stops: runsheetStops } = getShiftsStopsFromRunsheets([runsheet])

      dispatch(upsertMultipleRunsheetShifts(runsheetShifts))
      dispatch(upsertMultipleRunsheetStops(runsheetStops))
    }

    if (onSuccess) {
      onSuccess()
    }
  },
)
